import { IPuntosSalida } from '../../core/interfaces/exit-points.interface';

export class GetAllExitPointsAction {
  static readonly type = '[ExitPoint] Get All';
  constructor() {}
}

export class AddExitPointsAction {
  static readonly type = '[ExitPoint] Add New Exit Point';
  constructor(public payload: IPuntosSalida) {}
}

export class UpdatedExitPointsAction {
  static readonly type = '[ExitPoint] Updated Exit Point';
  constructor(public payload: IPuntosSalida) {}
}

export class DeleteExitPointsAction {
  static readonly type = '[ExitPoint] Delete';
  constructor(public payload: string) {}
}
